import ACTIONS from "../../constants/constants"

export const products2dFetch = () => dispatch => {
  return fetch(`/test_data/products.json`)
    .then(res => res.json())
    .then(res => {
      dispatch({
        type: ACTIONS.FETCH_2D_PRODUCTS,
        data: res,
      })
    })
    .catch(err => {
      console.log(err)
      throw err
    })
}

export const setProduct2d = payload => ({
  type: ACTIONS.SET_2D_PRODUCT,
  payload,
})

export const clearProduct2d = () => ({
  type: ACTIONS.CLEAR_2D_PRODUCT,
})

export const product2dFetch = slug => dispatch => {
  return fetch(`/test_data/products/${slug}.json`)
    .then(res => res.json())
    .then(res => {
      dispatch({
        type: ACTIONS.FETCH_2D_PRODUCT,
        data: res.parts,
      })
    })
    .catch(err => {
      console.log(err)
      throw err
    })
}
// ===========
export const setProduct2dActivePart = payload => ({
  type: ACTIONS.PRODUCT_2D_SET_ACTIVE_PART,
  payload,
})
export const clearProduct2dActivePart = () => ({
  type: ACTIONS.PRODUCT_2D_CLEAR_ACTIVE_PART,
})
// ===========
export const setProduct2dCanvasState = payload => ({
  type: ACTIONS.PRODUCT_2D_SET_CANVAS_STATE,
  payload,
})
export const clearProduct2dCanvasState = payload => ({
  type: ACTIONS.PRODUCT_2D_CLEAR_CANVAS_STATE,
  payload,
})
// ===========
export const setLeftWorkAreaState = payload => ({
  type: ACTIONS.P_2D_SET_LEFTWORKAREA_STATE,
  payload,
})
export const clearLeftWorkAreaState = () => ({
  type: ACTIONS.P_2D_CLEAR_LEFTWORKAREA_STATE,
})
// ===========
export const setProduct2dBaseColor = payload => ({
  type: ACTIONS.PRODUCT_2D_SET_BASE_COLOR,
  payload,
})

export const clearProduct2dBaseColor = () => ({
  type: ACTIONS.PRODUCT_2D_CLEAR_BASE_COLOR,
})

export const setActiveObject = payload => ({
  type: ACTIONS.P_2D_SET_ACTIVE_OBJECT,
  payload,
})

export const clearActiveObject = () => ({
  type: ACTIONS.P_2D_CLEAR_ACTIVE_OBJECT,
})

export const setLoader = payload => ({
  type: ACTIONS.SET_2D_LOADER,
  payload,
})

export const setActiveObjects = payload => ({
  type: ACTIONS.P_2D_SET_ACTIVE_OBJECTS,
  payload,
})

export const clearActiveObjects = () => ({
  type: ACTIONS.P_2D_CLEAR_ACTIVE_OBJECTS,
})
// ===========
// export const setProduct2dBaseColor = payload => ({
//   type: ACTIONS.PRODUCT_2D_SET_BASE_COLOR,
//   payload,
// })

// export const clearProduct2dBaseColor = () => ({
//   type: ACTIONS.PRODUCT_2D_CLEAR_BASE_COLOR,
// })
